import {Dialog, DialogPanel, DialogTitle} from "@headlessui/react";
import {DangerButton} from "../../Buttons/DangerButton";
import {SecondaryButton} from "../../Buttons/SecondaryButton";
import {ExclamationTriangleIcon} from "@heroicons/react/24/outline";
import {useTranslation} from "react-i18next";

export const RegenerateConfirmDialog = ({isOpen, onClose, onConfirm, isLoading = false}) => {
    const {t} = useTranslation();
    return (
        <Dialog open={isOpen} onClose={onClose} className="relative z-50">
            <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
            <div className="fixed inset-0 flex items-center justify-center p-4">
                <DialogPanel className="mx-auto max-w-lg rounded-lg bg-white p-6 shadow-xl">
                    <div className="flex items-start">
                        <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-yellow-100">
                            <ExclamationTriangleIcon className="h-6 w-6 text-yellow-600" aria-hidden="true" />
                        </div>
                        <div className="ml-4 flex-1">
                            <DialogTitle className="text-lg font-semibold text-gray-900 mb-2">
                                {t('performance_reports.regenerate_title')}
                            </DialogTitle>
                            <div className="mt-2 text-sm text-gray-600 space-y-2">
                                <p>
                                    <strong>{t('performance_reports.regenerate_warning')}</strong> {t('performance_reports.regenerate_message')}
                                </p>
                                <ul className="list-disc list-inside space-y-1 ml-2">
                                    <li>{t('performance_reports.regenerate_step_reset')}</li>
                                    <li>{t('performance_reports.regenerate_step_invalidate')}</li>
                                    <li>{t('performance_reports.regenerate_step_new')}</li>
                                </ul>
                                <p className="mt-3 font-medium">
                                    {t('dialogs.confirm.are_you_sure_continue')}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="mt-6 flex justify-end gap-3">
                        <SecondaryButton onClick={onClose} disabled={isLoading} outlined={true}>
                            {t('general.actions.cancel')}
                        </SecondaryButton>
                        <DangerButton onClick={onConfirm} disabled={isLoading}>
                            {isLoading ? (
                                <div className="flex items-center gap-2">
                                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                                    {t('performance_reports.regenerating')}
                                </div>
                            ) : (
                                t('general.actions.confirm')
                            )}
                        </DangerButton>
                    </div>
                </DialogPanel>
            </div>
        </Dialog>
    );
};
